<!--
 * TTTech nerve-ui-components
 * Copyright(c) 2021 TTTech Industrial Automation AG.
 *
 * ALL RIGHTS RESERVED.
 * Usage of this software, including source code, netlists, documentation,
 * is subject to restrictions and conditions of the applicable license
 * agreement with TTTech Industrial Automation AG or its affiliates.
 *
 * All trademarks used are the property of their respective owners.
 * TTTech Industrial Automation AG and its affiliates do not assume any liability
 * arising out of the application or use of any product described or shown
 * herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 * make changes, at any time, in order to improve reliability, function or
 * design.
 *
 * Contact Information:
 * support@tttech-industrial.com
 * TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 * -->

<template>
  <div v-if="capabilities.length > 0">
    <nerve-dialog v-model="dialog" persistent scrollable width="600">
      <template #activator="{ on, attrs }">
        <v-btn
          v-if="capitalLetters"
          id="iiotCapabilitiesBtn"
          v-bind="attrs"
          text
          color="primary"
          class="pa-0"
          v-on="on"
        >
          {{ $t('capability.capabilities') }}
        </v-btn>
        <a v-else id="iiotCapabilitiesBtn" ref="secureId" v-bind="attrs" class="router-link" @click="dialog = true">
          {{ $t('capability.capabilities') }}
        </a>
      </template>

      <v-card class="capabilities-dialog">
        <v-card-title>
          {{ $t('capability.nodeCapabilities') }}
        </v-card-title>

        <v-card-text class="text-left">
          <div class="vertical-scrollbar">
            <v-list id="iiotCapabilitiesList" disabled>
              <v-list-item-group color="primary">
                <v-list-item v-for="(capability, i) in capabilities" :key="i" class="row-background-color mb-3">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ text ? capability[text] : capability }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </v-card-text>

        <v-card-actions class="mt-10">
          <nerve-button
            id="iiotCapabilitiesCloseBtn"
            :text="$t('capability.close')"
            type-of-btn="close"
            size="normal"
            @click-event="dialog = false"
          />
        </v-card-actions>
      </v-card>
    </nerve-dialog>
  </div>
</template>

<script>
import NerveButton from '../NerveButton.vue';
import NerveDialog from '../NerveDialog.vue';

export default {
  name: 'NodeReboot',
  components: {
    NerveButton,
    NerveDialog,
  },
  props: {
    capabilities: {
      type: Array,
      default: () => [],
    },
    capitalLetters: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped lang="scss">
.primary-tttech-background-btn {
  background-image: linear-gradient(to bottom, var(--v-primary-base), var(--v-primary-darken1));
}

.primary-tttech-background-btn-disabled {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12));
}

.primary-tttech-background-for-btn {
  background-image: linear-gradient(to bottom, var(--v-primary-base), var(--v-primary-darken1));
}
.tertiary-tttech-background-for-btn {
  background-image: linear-gradient(to bottom, var(--v-tertiary-lighten4), var(--v-tertiary-base));
}

.btn-appearance {
  @extend .primary-tttech-background-for-btn;
  width: 100%;
  height: 40px !important;
  text-transform: none;
  color: var(--v-secondary-base) !important;
  font-weight: bold !important;
  font-size: 16px;
  line-height: 1px;
  flex: 1 0 auto;
}

.btns {
  @extend .btn-appearance;
  margin-top: 76px;
  margin-bottom: 40px;
  &.cancel {
    @extend .tertiary-tttech-background-for-btn;
  }
}
.dialogBtns {
  @extend .btn-appearance;
  margin-top: 0;
  margin-bottom: 0;
  &.cancel {
    @extend .tertiary-tttech-background-for-btn;
  }
}
.btns[disabled] {
  background-image: none;
  background-color: #e9e9e9;
  color: #ffffff;
}
.headerTitle {
  > h1 {
    text-align: left;
    font-size: 25px !important;
    font-weight: 800 !important;
    margin-top: 0;
    margin-bottom: 0;
  }

  > .v-divider {
    border-top-width: 3px !important;
    border-top-color: #00c5ea;
    width: 41px;
    margin: 0;
    margin-bottom: 15px;
  }
}

.row-background-color {
  background-color: #f0f3f5;
  max-height: 300px !important;
}

.vertical-scrollbar {
  max-height: 30vh;
  overflow-y: auto;
}

.v-card .v-divider {
  margin-left: 0px !important;
}
.capabilities-dialog {
  min-height: 320px !important;
}
</style>
